import React, { useState } from "react";
import ErrorBoundary from "../components/errorBoundary";
import MatchList from "../components/matches/matchList";
import ChampionshipBar from "../components/championshipBar";
import { Match } from "../types";
import MatchDetail from "../components/matches/matchDetail";

const Matches = () => {
	const [selectedMatch, selectMatch] = useState(null as Match);

	return (
		<div>
			<h1 className="h2">Matches</h1>

			<ErrorBoundary>
				Matches
				<MatchList onSelect={selectMatch} />
				{selectedMatch ? <MatchDetail match={selectedMatch} /> : <ChampionshipBar />}
			</ErrorBoundary>
		</div>
	);
};

export default Matches;
